<canvas #chart role="img" [attr.aria-label]="ariaLabel()" [attr.aria-labelledby]="ariaLabelledBy()"></canvas>
